module.exports = __webpack_public_path__ + "img/button-trezor.5fa0fa11.svg";